/* eslint-disable */
/**
 * Created by andrey on 15.06.2022.
 */

// ES2022 https://github.com/tc39/proposal-relative-indexing-method
if (Array.prototype.at === undefined) {
    [Array, String].forEach((C) => {
        Object.defineProperty(
            C.prototype, 
            "at",
            {
                writable: true,
                enumerable: false,
                configurable: true,
                value: function at(n) {
                    // ToInteger() abstract op
                    n = (n < 0 ? Math.ceil(n) : Math.floor(n)) || 0;
                    // Allow negative indexing from the end
                    if (n < 0) {
                        n += this.length;
                    }
                    // OOB access is guaranteed to return undefined
                    if (n < 0 || n >= this.length) {
                        return undefined;
                    }
                    return this[n];
                }
            }
        );
    });
}

// ES2021
if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (pattern, replacement) {
        if (typeof pattern === "string") { 
            pattern = pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }

        return this.replace(new RegExp(pattern, "g"), replacement);
    };
}

// ES2019
if (Array.prototype.flat === undefined) {
    Object.defineProperty(Array.prototype, "flat", {
        value: function flat() {
            const depth = isNaN(arguments[0]) ? 1 : Number(arguments[0]);

            return depth ? Array.prototype.reduce.call(this, (acc, cur) => {
                if (Array.isArray(cur)) {
                    acc.push.apply(acc, flat.call(cur, depth - 1));
                } else {
                    acc.push(cur);
                }

                return acc;
            }, []) : Array.prototype.slice.call(this);
        },
        configurable: true,
        writable: true
    });
}

// ES2019
if (Array.prototype.flatMap === undefined) {
    Object.defineProperty(Array.prototype, 'flatMap', {
        value: function(callback, thisArg) {
            var self = thisArg || this;
            if (self === null) {
                throw new TypeError( 'Array.prototype.flatMap ' +
                    'called on null or undefined' );
            }
            if (typeof callback !== 'function') {
                throw new TypeError( callback +
                    ' is not a function');
            }

            var list = [];

            var o = Object(self);

            var len = o.length >>> 0;

            for (var k = 0; k < len; ++k) {
                if (k in o) {
                    var part_list = callback.call(self, o[k], k, o);
                    list = list.concat(part_list);
                }
            }

            return list;
        }
    });
}

// ES2019
if (Object.fromEntries === undefined) {
    Object.defineProperty(Object, "fromEntries", {
        value: function fromEntries(entries) {
            const object = {};

            for (const entry of entries) {
                object[entry[0]] = entry[1];
            }

            return object;
        },
        configurable: true,
        writable: true
    });
}

if (Number.isFinite === undefined) {
    Number.isFinite = function (value) {
        return typeof value === "number" && isFinite(value);
    };
}